import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../firebase/config";

/**
 * Subscribe to a Firestore collection, live-updating on any change.
 * @param {string} path — collection path (e.g. "news")
 * @param {string} orderField — field to sort by (default "order")
 * @param {"asc"|"desc"} direction
 */
export function useCollection(path, orderField = "order", direction = "asc") {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const q = query(collection(db, path), orderBy(orderField, direction));
    const unsub = onSnapshot(
      q,
      (snap) => {
        setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );
    return unsub;
  }, [path, orderField, direction]);

  return { items, loading, error };
}
